import { Button, Flex, Spacer, Text } from '@chakra-ui/react'
import React from 'react'
import { excelFileTypes } from '@/utils/constants'

const QuotationDetailTableToolbar = ({
  title = 'Quotation Details',
  disabled = false,
  importExcelRef,
  onImportExcel,
  onDownload,
  onAddRow,
}) => {
  return (
    <Flex justifyItems={'flex-end'} w="100%" alignItems="center" gap="3">
      <Text as={'b'}>{title}</Text>
      <Spacer></Spacer>

      {onImportExcel && importExcelRef && (
        <input type="file" ref={importExcelRef} accept={excelFileTypes} disabled={disabled} onChange={onImportExcel} />
      )}

      <Button colorScheme={'green'} onClick={onDownload}>
        Download
      </Button>

      <Button onClick={onAddRow} colorScheme="green" isDisabled={disabled}>
        Add Row
      </Button>
    </Flex>
  )
}

export default QuotationDetailTableToolbar
